import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'
import { LayoutTwo } from "../Layout";


class ProjectList extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        let projects = this.props.filteredProjects;

        let projectsData = projects.map((item, key) => {
            let index = key <= LayoutTwo.length - 1 ? key : key % (LayoutTwo.length - 1);
            let img1 = item.listing_images_1 ? item.listing_images_1.url : false;
            let img2 = item.listing_images_2 ? item.listing_images_2.url : false;
            let cls = item.listing_view ? item.listing_view : 'fig-p';

            return img1 ? (
                <div className="project-list-item">
                    <article>
                        <h5 className="--title font-lg"><Link className="c-workplace c-hvr-general" exact to={`${process.env.PUBLIC_URL}/project/${item.post_name}`}>{item.post_title}</Link></h5>
                        <p className="--sector c-workplace">{item.project_sub_heading}</p>
                        <table className="--table-info">
                            <tbody>
                                {item.completion_year && <tr><td>Completion</td><td>{item.completion_year}</td></tr>}
                                {item.sector && <tr><td>Sector</td><td>{item.sector}</td></tr>}
                                {item.location && <tr><td>Location</td><td>{item.location}</td></tr>}
                                {item.client && <tr><td>Client</td><td>{item.client}</td></tr>}
                                {item.photography && <tr><td>Photography</td><td>{item.photography}</td></tr>}
                            </tbody>
                        </table>
                    </article>
                    <figure>
                        <Link className="link project-link" exact to={`${process.env.PUBLIC_URL}/project/${item.post_name}`}></Link>
                        <img src={img1} alt={item.post_title} />
                        <img src={img2} alt={item.post_title} />
                    </figure>
                </div>
            ) : []
        })
        return (
            <div className="mole__project-list fullW">
                <div className="main-container">
                    <div className="inner-container">
                        {projectsData }
                    </div>
                </div>
            </div>
        );
    }
}
export default ProjectList;



// WEBPACK FOOTER //
// ./src/components/Projects/List/ProjectList.js